<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="py-8 mx-auto max-w-6xl lg:py-16">
      <div v-if="loading">
        <UiSpinner />
      </div>
      <div v-if="!loading" class="grid gap-4 px-4 mb-4 sm:mb-5 sm:grid-cols-3 sm:gap-6 md:gap-12">
        <div class="sm:col-span-2">
          <h2
            class="flex items-center mb-4 text-xl font-bold leading-none text-gray-900 sm:text-2xl dark:text-white sm:mb-5">
            {{ contentInfo['content_type']['name'] }}
          </h2>
          <dl class="flex items-center mb-4 space-x-4 sm:mb-5">
            <div>
              <dt class="sr-only">
                Type
              </dt>
              <dd class="flex items-center text-gray-900 dark:text-white">
                <i class="fa fa-pen text-gray-400 dark:text-gray-500 mr-1.5"></i>
                <span class="font-semibold">Content Template</span>
              </dd>
            </div>
          </dl>
          <dl>
            <dt class="mb-2 font-semibold leading-none text-gray-900 dark:text-white">
              Details:
            </dt>
            <dd class="font-light text-gray-500 dark:text-gray-400">
              {{ contentInfo['content_type']['description'] }}
            </dd>
          </dl>
        </div>
        <!-- Column -->
        <dl class="p-4 bg-gray-50 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600">
          <dt class="mb-2 leading-none text-gray-500 dark:text-gray-400">
            Authors
          </dt>
          <dd class="flex mb-4 -space-x-4 sm:mb-5">
            <img class="w-8 h-8 rounded-full border-2 border-gray-50 dark:border-gray-700"
              src="https://growthfoundry.com/static/marketing/img/content/team-members/nate_fischer.png"
              alt="N Fischer">
            <button type="button"
              class="flex justify-center items-center w-8 h-8 text-xs font-medium text-white bg-gray-600
                rounded-full border-2 border-gray-50 hover:bg-gray-500 dark:border-gray-700">
              +2
            </button>
          </dd>
          <dt class="mb-2 leading-none text-gray-500 dark:text-gray-400">
            Category
          </dt>
          <dd class="mb-4 font-medium text-gray-900 sm:mb-5 dark:text-white">
            {{ contentInfo['content_type']['category'] }}
          </dd>
        </dl>
      </div>
    </div>
  </section>
</template>

<script setup>
import axios from 'axios'
import { ref, onMounted, defineProps } from 'vue'
import UiSpinner from '@ui/spinner.vue'

const props = defineProps({
  locationId: String,
  contentTypeId: String
})

const contentInfo = ref(null)
const loading = ref(true)

const getInfo = () => {
  axios.get(`/ajax/clients/ai_content/content_types/${props.contentTypeId}/info`)
    .then((response) => {
      contentInfo.value = response.data
      loading.value = false
    })
    .catch(console.error)
}

onMounted(getInfo)
</script>
